var React = require('react');

function BtnArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_473","data-name":"Group 473","transform":"translate(-342.21 -780.945)"},[React.createElement("path",{"id":"Path_418","data-name":"Path 418","d":"M3834.563,2765.307l7.705-7.7","transform":"translate(-3492 -1973.83)","fill":"none","stroke":"#4b4b4b","strokeWidth":"1","key":0}),React.createElement("path",{"id":"Path_419","data-name":"Path 419","d":"M0,3.281,2.281,0,4.563,3.281","transform":"translate(348.985 781.854) rotate(45)","fill":"none","stroke":"#4b4b4b","strokeWidth":"1","key":1})]));
}

BtnArrow.defaultProps = {"width":"10.912","height":"10.886","viewBox":"0 0 10.912 10.886"};

module.exports = BtnArrow;

BtnArrow.default = BtnArrow;
